
import MdContent from 'components/md-content-v2'
import SaveDoc from '../save-doc.vue'

export default {
  components: {MdContent, SaveDoc},  
  props: {
    info: {type: Object, required: false, default: undefined},
    loading: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
  },
  emits: ['follow', 'save'],
  computed: {
    name() {
      return this.info?.name
    },
    image_url() {
      return this.info?.image_url
    },
    position() {
      return this.info?.position
    },
    company() {
      return this.info?.company
    },
    bio() {
      return this.info?.bio
    },
    email() {
      return this.info?.email
    },
    phone() {
      return this.info?.phone
    },
    linkedin_url() {
      return this.info?.linkedin_url
    },
    shared_contact_id() {
      return this.info?.shared_contact_id
    },
    initials(){
      if(this.name){
        const name = this.name.split(' ')
        return name.length > 1 ? name[0][0] + name[1][0] :  name[0][0]
      }
      return undefined
    }
  },
  methods: {
    callPhone(){
      const phone = document.createElement('a')
      phone.href = `tel:${this.phone}`
      phone.click()
    },
    sendMail(){
      const mail = document.createElement('a')
      const body = encodeURIComponent(`Hello ${this.name}!`)
      mail.href = `mailto:${this.email}?body=${body}`
      mail.click()
    },
    openLinkedin() {
      window.open(this.linkedin_url, '_blank')
    }
  }
}
